<template>
  <div class="loading-cargo-info" v-if="getOrder($route.params.orderId)">
    <div class="cargo-loading container-fluid pl-0 pr-0">
      <div class="info-bar-back">
        <template>
          {{getOrder($route.params.orderId).title}}
        </template>
        <router-link tag="a" :to="{name:'teamlead-unloading-sender-overview'}" class="float-right">
          {{$t('button.back')}}
        </router-link>
      </div>
      <div class="scrollable-cargo-order-container">
        <div>
          <div class="row ml-0 mr-0">
            <div class="col-7">
              <p class="cargo"><strong>{{getOrder($route.params.orderId).title}}</strong></p>
              <p class="company">{{getOrder($route.params.orderId).receiverName}}</p>
            </div>
<!--            <div class="col-3 available-productlines">-->
<!--              <p class="cargo"> &nbsp;</p>-->
<!--              <p><i class="fas fa-cubes"/>-->
<!--                {{ picLocationsWithProduct.length }} / {{picLocationsWithProduct.length +-->
<!--                productsWithoutPickLocation.length-->
<!--                }}-->
<!--              </p>-->
<!--            </div>-->
            <div class="col-2 loading-check" v-if="isFullypicked">
              <transition name="fade" appear>
                <i class="fas fa-check"/>
              </transition>
            </div>
          </div>
          <div class="row ml-0 mr-0">
            <div class="col-12">
              <div class="order-destination">
                <orderDestination :order="getOrder($route.params.orderId)"/>
                <template v-if="picLocationsWithProduct.length">
                  <orderProducts :locationType="'unloading'" :order=order :key="'pl-id'+idx"
                                 v-for="(product,idx) in picLocationsWithProduct"
                                 :product="product"/>
                </template>
                <template>
                  <orderProducts :locationType="'unloading'" :order=order :key=idx
                                 v-for="(product,idx) in productsWithoutPickLocation"
                                 :product="product"/>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import orderDestination from './../../components/loading/OrderDestination';
  import orderProducts from './../../components/loading/OrderProducts';
  import {mapGetters} from 'vuex';


  export default {
    name: 'loaded-Cargo-Details',
    components: {
      orderDestination,
      orderProducts
    },
    data() {
      return {
        order: [],
        loadingLocations: false,
        orderProducts: [],
        pickLocations: [],
        fullyPickedTest: true
      };
    },
    computed: {
      ...mapGetters(['getAPICompanyID']),
      ...mapGetters('incomingOrderProducts', ['getProductsFromOrder']),
      ...mapGetters('incomingOrders', ['getOrder']),
      ...mapGetters('pickLocations', ['getPickLocationsForOrder']),
      picLocationsWithProduct() {
        let pickLocations = this.getPickLocationsForOrder(this.$route.params.orderId);
        let orderProducts = this.getProductsFromOrder(this.$route.params.orderId);

        _.each(pickLocations, (loc) => {
          let productInfo = _.find(orderProducts, (prod) => {
            return prod.id.toString() === loc.orderProductId.toString() && loc.amount > 0;
          });
          loc = {...loc, ...productInfo};
        });
        return pickLocations;
      },
      productsWithoutPickLocation() {
        let orderProducts = this.getProductsFromOrder(this.$route.params.orderId);
        let pickLocations = this.getPickLocationsForOrder(this.$route.params.orderId);
        if(!pickLocations.length) {
          return orderProducts;
        }
        let pickLocIds = pickLocations.map(locs => {
          return locs.productNumber;
        });
        let orderProductsWithoutLocation = _.filter(orderProducts, (product) => {
          return !_.includes(pickLocIds, product.productNumber);
        });

        return orderProductsWithoutLocation;
      },
      isFullypicked() {
        let order = this.getOrder(this.$route.params.orderId)
         return order.fullyUnloaded
      },
      allProductsPicked() {
        if(!this.orderProducts.length) {
          return false;
        }
        return _.every(this.orderProducts, (product) => {
          if(product.location) {
            return product.location.amountPickable <= product.location.amountPicked;
          } else {
            return false;
          }
        });
      }
    },
    async beforeRouteLeave(from, to, next) {
      await this.$store.dispatch('resetStoreModules', ['incomingOrders', 'incomingOrderProducts']);
      await this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);
      next();
    },
    created() {

      this.$store.dispatch('initDataForPage', ['incomingOrders','incomingOrderProducts' ])
    }
  };
</script>

<style lang="scss">
  .barcode-input-wrap {
    position: fixed;
    z-index: 11;
    width: calc(100% - 250px);
    bottom: 0;
    padding: 10px 15px 0;
    background: #f5f5f5;
    border-top: 1px solid #dcdcdc;

    &:hover {
      cursor: pointer;
    }

    .toggle-barcode {
      right: 15px;
      position: absolute;
      line-height: 42px;
      top: 0;
    }

    label {
      text-transform: uppercase;
      white-space: nowrap;
      margin: 0 0 10px;
    }
  }

  .unloading-info:last-child {
    margin-bottom: 42px;
  }

  .show-manual-barcode {
    padding-bottom: 15px;

    .unloading-info:last-child {
      margin-bottom: 102px;
    }
  }

  @media (max-width: 1200px) {
    .barcode-input-wrap {
      width: 100%;
    }
  }
</style>